import React, { Component, Fragment } from 'react';
import Hero from './Hero';
import HomeContent from './HomeContent';

export default class Home extends Component {
// export default function Home() {
  render() {
  return (
    <Fragment>
      <Hero />
      <div className="box cta">
        <p className="has-text-centered">
          <span className="tag is-primary">New</span> The new Kealow website!
        </p>
      </div>
      <HomeContent />
    </Fragment>
  )
      }
}
